/* istanbul ignore file */
export * from './ProductListPagination';
